import { SET_HANGEFIRE, SET_HANGEFIRE_READY_STATUS } from "./actionType";

const init = {
  isReady: false,
  header: {},
  items: [],
  isWorking: false,
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case SET_HANGEFIRE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_HANGEFIRE_READY_STATUS:
      return {
        ...state,
        isReady: action.payload,
      };

    default:
      return state;
  }
}
